import { salesHttp } from "../../salesDi";
import actions from "./actions";
import presenters from "./presenters";
import repositories from "./repositories";
import useCases from "./useCases";
var cRepositorires = repositories(salesHttp);
var cUseCases = useCases(cRepositorires);
var cActions = actions();
var cPresenters = presenters(cUseCases, cActions);
export default {
    aifPms: cPresenters.aifPms,
    payment: cPresenters.payment,
    draft: cPresenters.draft,
    purchase: cPresenters.purchase,
    global: cPresenters.global,
    orderBook: cPresenters.orderBook,
    leadservice: cPresenters.leadservice,
    qualityCheck: cPresenters.qualityCheck,
};
